import { Component, Element, h, Host, Prop } from "@stencil/core";

/**
 *
 */
@Component({
  tag: "stzh-quote",
  styleUrl: "stzh-quote.scss",
  scoped: true,
})
export class StzhQuote {
  @Element() element: HTMLStzhListElement;

  /* Text for quote */
  @Prop() text: string = "";

  /* Text for author */
  @Prop() author: string = "";

  render() {
    const classes = {
      "stzh-quote": true,
    };

    return (
      <Host>
        <div class={classes}>
          <blockquote class="stzh-quote__content">
            <p class="stzh-quote__text">{this.text}</p>
            {this.author && <cite class="stzh-quote__author">{this.author}</cite>}
          </blockquote>
        </div>
      </Host>
    );
  }
}
